import HeaderTitle from 'Components/HeaderTitle/HeaderTitle';
import { Content } from 'Constants/styles';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import setBodyOverflow from 'utils/setBodyOverflow';

import MerchantPersons from '../MerchantOnboarding/BeneficialOwners';
import OnboardingStatus from './OnboardingStatus';
import UpdateBusinessProfile from './UpdateBusinessProfile';

const MerchantOnboarding = () => {
  const { merchantId } = useParams<{ merchantId: string }>();

  useEffect(() => {
    setBodyOverflow('auto');
  }, []);

  return (
    <>
      <HeaderTitle title="Merchant onboarding" />
      <Content>
        <OnboardingStatus />
        <UpdateBusinessProfile merchantId={merchantId} />
        <MerchantPersons merchantId={merchantId} />
      </Content>
    </>
  );
};

export default MerchantOnboarding;
